// routes/_app.profile.edit.security.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/_app.profile.edit.security')

export const handle = {
  name: 'profile/edit/security',
  track: { scene: 'profile-edit', section: 'security' },
}

export default dynamic(getClientModule, { ssr: false })
